import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-95555b0a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "MossCopyRenderContainer"
};
const _hoisted_2 = {
  class: "ft20"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "点击查看图例，你将看到由 \".\" \"|\" \"-\" 三种元素组合而成10种符号，每组符号分别对应0~9不同的代码,", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "并尽量快尽量准确的根据符号特征选择符号代码。", -1));
const _hoisted_5 = {
  class: "ml16 ft20"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "图例展示完毕，请答题", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_button = _resolveComponent("el-button");
  const _component_MossSymbol = _resolveComponent("MossSymbol");
  const _component_el_col = _resolveComponent("el-col");
  const _component_MossAnswerOption = _resolveComponent("MossAnswerOption");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
    class: "bothCenter"
  }, {
    default: _withCtx(() => [_createElementVNode("span", _hoisted_2, "第" + _toDisplayString($props.data.questionIndex + 1) + "题", 1)]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "flex flex-col mt16"
  }, {
    default: _withCtx(() => [_hoisted_3, _createElementVNode("span", null, "请你在" + _toDisplayString($props.difficulty.flashInterval) + "秒内尽可能的记住屏幕中显示的符号特征及相应的代码，", 1), _hoisted_4]),
    _: 1
  }), $data.visible == 0 ? (_openBlock(), _createBlock(_component_el_row, {
    key: 0,
    class: "bothCenter mt32",
    style: {
      "min-height": "250px"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_el_button, {
      size: "large",
      style: {
        "width": "100px"
      },
      onClick: $options.showExample,
      type: "primary"
    }, {
      default: _withCtx(() => [_createTextVNode("查看图例")]),
      _: 1
    }, 8, ["onClick"])]),
    _: 1
  })) : _createCommentVNode("", true), $data.visible == 1 ? (_openBlock(), _createBlock(_component_el_row, {
    key: 1,
    class: "bothCenter mt32",
    style: {
      "min-height": "250px"
    }
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data.mappings, (s, si) => {
      return _openBlock(), _createBlock(_component_el_col, {
        span: 12,
        class: "bothCenter mt16",
        key: s
      }, {
        default: _withCtx(() => [_createVNode(_component_MossSymbol, {
          symbol: s
        }, null, 8, ["symbol"]), _createElementVNode("span", _hoisted_5, _toDisplayString(si), 1)]),
        _: 2
      }, 1024);
    }), 128))]),
    _: 1
  })) : _createCommentVNode("", true), $data.visible > 1 ? (_openBlock(), _createBlock(_component_el_row, {
    key: 2,
    class: "bothCenter mt32",
    style: {
      "min-height": "250px"
    }
  }, {
    default: _withCtx(() => [_hoisted_6]),
    _: 1
  })) : _createCommentVNode("", true), (_openBlock(), _createBlock(_component_el_row, {
    class: "bothCenter mt64 mb32",
    key: `moss_q_${$props.data.questionIndex}`
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data.questions, (q, qi) => {
      return _openBlock(), _createBlock(_component_el_col, {
        span: 6,
        class: "flex flex-col bothCenter",
        key: q
      }, {
        default: _withCtx(() => [_createVNode(_component_MossAnswerOption, {
          symbol: q,
          review: $props.review ? $props.review.answer.split(',')[qi] : null,
          onSelect: v => $options.onSelect(qi, v)
        }, null, 8, ["symbol", "review", "onSelect"]), $props.review ? (_openBlock(), _createBlock(_component_el_row, {
          key: 0,
          class: "flex flex-col mt16"
        }, {
          default: _withCtx(() => [_createElementVNode("span", null, "正确答案：" + _toDisplayString($props.data.rightAnswers[qi]), 1), _createElementVNode("span", {
            style: _normalizeStyle({
              color: $props.review.result ? 'green' : 'red'
            })
          }, "您的答案：" + _toDisplayString($props.review.answer.split(',')[qi]), 5)]),
          _: 2
        }, 1024)) : _createCommentVNode("", true)]),
        _: 2
      }, 1024);
    }), 128))]),
    _: 1
  }))]);
}